import type { NuasApp, Result } from '@eliboo/api-models';
import type { CommonHttpOptions} from '@eliboo/api/common';

import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { mergeOptions } from '@eliboo/api/common';

export type GetLicenseUserInfoResType = NuasApp.SimpleNuasMemberUserAccountAndBaseInfoDTO;
export function useApiGetLicenseUserInfo(defaultOptions?: CommonHttpOptions) {
  const http = inject(HttpClient);
  const url = `/nuas-app-boot/app-api/v1/userBusinessLicenseInfo/getUserInfo`;
  function api(httpOptions?: CommonHttpOptions) {
    const options = mergeOptions(defaultOptions, httpOptions);
    return http.get<Result<GetLicenseUserInfoResType>>(url, options);
  }
  return { url, api };
}
